import { URL_PATTERN } from '../constants';

export function detectLinks(text: string): boolean {
    if (!text || typeof text !== 'string') {
        return false;
    }

    return URL_PATTERN.test(text);
}
